import CryptoJS from 'crypto-js';

// 密钥（必须：前后端保持一致，建议16/24/32位字符，对应AES-128/192/256）
const SECRET_KEY = CryptoJS.enc.Utf8.parse('1234567890abcdef'); // 16位密钥
// 偏移量（可选，AES-CBC模式必需，建议16位）
const IV = CryptoJS.enc.Utf8.parse('abcdef1234567890');

/**
 * URL 加密（AES-CBC 模式）
 * @param {String} url - 原始链接
 * @returns {String} 加密后的字符串（Base64 格式，便于传输）
 */
export function encryptUrl(url) {
  const encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(url),
    SECRET_KEY,
    {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );
  // 转为 Base64 字符串（避免特殊字符，便于URL传输）
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}

/**
 * URL 解密
 * @param {String} encryptedStr - 加密后的字符串
 * @returns {String} 解密后的原始链接
 */
export function decryptUrl(encryptedStr) {
  const ciphertext = CryptoJS.enc.Base64.parse(encryptedStr);
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext },
    SECRET_KEY,
    {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );
  return decrypted.toString(CryptoJS.enc.Utf8);
}